const useImpactedTaskMessageSummary = ({
  releasedAllocationHours,
  impactedTaskSummary
}) => {
  const messages = [];
  const { taskUris, totalHoursRemainingAsOfDate: taskAllocationHours } =
    impactedTaskSummary || {};
  const taskAssignmentCount = taskUris?.length;

  if (taskAllocationHours > 0) {
    messages.push({
      messageId: 'changeResourceDialog.impactedTaskSummary.taskAllocationHours',
      values: { taskAllocationHours: taskAllocationHours.toFixed(2) }
    });
  } else if (releasedAllocationHours) {
    messages.push({
      messageId:
        'changeResourceDialog.impactedTaskSummary.releasedAllocationHours',
      values: { releasedAllocationHours: releasedAllocationHours.toFixed(2) }
    });
  }

  if (taskAssignmentCount) {
    messages.push({
      messageId: 'changeResourceDialog.impactedTaskSummary.taskAssignmentCount',
      values: { taskAssignmentCount }
    });
  }

  return {
    messages,
    title: { messageId: 'changeResourceDialog.impactedTaskSummary.title' }
  };
};

export default useImpactedTaskMessageSummary;
